import Content from "components/helpers/action-text/content";
import useAppContext from "lib/hooks/use-app-context";
import {isBlankHTML} from "lib/ext/string";

export default function Home() {
  const {page} = useAppContext();

  return (
    <div className="container">
      <div className="max-w-screen-lg mx-auto">
        {!isBlankHTML(page.content) && (
          <div className="custom-html">
            <Content html={page.content} />
          </div>
        )}
      </div>
    </div>
  );
}
